import { Grid, Typography, Box, Card, CardContent } from "@mui/material";

import artistPhoto from "../../../static/images/TSDD/dave_davidson.webp"

const TEXT_COLOR = "#fff";

const Paragraph = ({ title, children, smallTitle }) => {
  return <Box sx={{ mt: 2, textAlign: "left" }}>

    <Typography sx={{ fontSize: { md: "23px", xs: "16px" } }} variant="body2" ><b>{title}:</b> {children}</Typography>
  </Box>
}

const OverviewBanner = () => {
  return <Grid container sx={{
    width: "100%",
    pt: "80px",
    pb: { xs: 0, md: 20 },
    // minHeight: "100vh",
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(0, 0, 0, 1.0) 0%, #1a1a1a 99%)",
  }}

    justifyContent={"center"} >

    <Grid item id="overview" xs={12} md={6} justifyContent={"center"} alignItems={"center"} sx={{ pl: { xs: 4, md: 10 }, pr: { xs: 4, md: 10 } }} >
      <Typography variant="h3" sx={{ mb: { xs: 2, md: 5 } }}>
        About the plugin
      </Typography>

      <Typography sx={{ fontSize: { md: "23px", xs: "16px" } }} variant="body2">
        <i>“My plugin suite was designed with versatility in mind. I worked meticulously with the WaveMind team to ensure every amp, cab, and pedal met my standards, and I'm truly blown away by the result.

          <p>The range of tones you can dial in with this suite is staggering. Whether you're after ripping thrash articulation, chunky death-metal rhythms, searing leads, or a lush, beautiful clean tone, this plugin has you covered.</p>

          <p>It's packed with powerful features like a doubler, cab splitter, and a dedicated EQ panel to fine-tune your sound. Beyond being incredibly inspiring to play, it's also intuitive and easy to use. I'm very proud to call this my signature suite, it delivers a ton of bang for your buck and incredible tone. Now go forth and let the riffs flow.”</p>
        </i>

      </Typography>
      <Typography sx={{ float: "right", mt: -1, ml: "auto", mr: 0, fontSize: { md: "23px", xs: "16px" } }} variant="body2">
        <i>- Dave Davidson </i>
      </Typography>

      <Typography sx={{ mt: { xs: 7, md: 10 }, fontSize: { md: "23px", xs: "16px" } }} variant="body2">
        <b>ToneSuite - Dave Davidson</b> was created in close collaboration with guitarist <a href="https://www.davedavidsonguitar.com/about/biography" style={{ textDecoration: "underline" }}><i>Dave Davidson</i></a>, capturing the full spectrum of his sound. From crushing Death Metal rhythm & lead tones to lush, articulate jazz cleans. This plugin delivers razor-sharp precision, dynamic response, and musical clarity at any gain level, making it an inspiring and versatile tool for writing, recording, and refining your tone. </Typography>
    </Grid >

    <Grid item id="overview" xs={12} md={6} justifyContent={"center"} alignItems={"center"} sx={{ mt: { xs: 5, md: 0 }, pr: { xs: 0, md: 10 } }} >
      <Box sx={{ height: "100%", display: { xs: "none", md: "flex" }, alignItems: "center", borderRadius: { xs: 0 }, width: "100%", overflow: "hidden" }}>
        <img loading="lazy" src={artistPhoto} alt="Dave Davidson" style={{ width: "100%", borderRadius: "20px" }} />
      </Box>

      <Box sx={{ height: "100%", display: { xs: "flex", md: "none" }, alignItems: "center", borderRadius: { xs: 0 }, width: "100%", overflow: "hidden" }}>
        <img loading="lazy" src={artistPhoto} alt="Dave Davidson" style={{ width: "100%" }} />
      </Box>
    </Grid >
  </Grid >
}

export default OverviewBanner;
